import TextField from '@/components/UI/textField/TextField'
import styles from './InformationForm.module.scss'
import { ChangeEvent, FormEvent, useEffect, useRef, useState } from 'react'
import Button from '@/components/UI/button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { completeProfile } from '@/redux/store/actions/auth'
import useLogin from '../../../hooks/useLogin'
import Box from '@/components/UI/box/Box'
import { toast } from 'react-toastify'

const InformationForm = () => {
  const user_info = useSelector(state => state.bootstrapData?.data?.user_info)
  const dispatch = useDispatch()
  const { phoneNumberDefault, otpDefault, loginCallback } = useLogin()

  const [form, setForm] = useState({
    name: '',
    family: '',
  })
  const [loading, setLoading] = useState(false)
  const inputNameRef = useRef<HTMLInputElement>(null)
  const isLogin = user_info?.uid

  const removeSpaces = (str: string) => str.trim().replace(/\s+/g, ' ')

  useEffect(() => {
    if (isLogin) {
      loginCallback({ isHost: false })
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'sign_up',
        user_id: user_info?.uid,
        phone_number: phoneNumberDefault,
        signup_date: new Date().toISOString(),
      })
    } else {
      // handle Iphone keyboard popup
      requestAnimationFrame(() => {
        inputNameRef.current?.focus()
      })
    }
  }, [isLogin])

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  const handleClear = (inputName: 'name' | 'family') => {
    setForm(prev => ({
      ...prev,
      [inputName]: '',
    }))
  }

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const formattedname = removeSpaces(form.name)
    const formattedFamily = removeSpaces(form.family)

    if (!formattedname || !formattedFamily) {
      toast.error('لطفاً نام و نام خانوادگی را به درستی وارد کنید')
      return
    }

    setLoading(true)

    dispatch(
      completeProfile(
        {
          name: formattedname,
          family: formattedFamily,
          mobile: phoneNumberDefault || '',
          code: Number(otpDefault),
        },
        ({ status, message }) => {
          if (status === 'ERROR') {
            setLoading(false)
            toast.error(message)
          }
        },
      ),
    )
  }

  return (
    <form className={styles['information-form']} onSubmit={handleSubmit}>
      <Box className={styles['inputs']}>
        <TextField
          ref={inputNameRef}
          label="نام"
          name="name"
          onChange={handleInput}
          value={form.name}
          onClear={() => handleClear('name')}
          disabled={loading}
          sizes={'medium'}
        />
        <TextField
          label="نام خانوادگی"
          name="family"
          onChange={handleInput}
          value={form.family}
          sizes={'medium'}
          onClear={() => handleClear('family')}
          disabled={loading}
        />
      </Box>
      <Button
        disabled={!form.name.trim() || !form.family.trim() || loading}
        data-auth="auth-register-submit-button"
        type="submit"
        format="primary"
        size={'large'}
        loading={loading}
      >
        ثبت نام
      </Button>
    </form>
  )
}

export default InformationForm
